import React from "react";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { IconboxReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/RestaurantChain/IconboxReusableComponent";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

const RestaurantChainsListComponent = ({ localProps, state, ...props }) => {
  let restaurant_list = state.all_restaurant_chains;
  if (state.search !== "") {
    let searchExp = new RegExp(state.search, "i");
    restaurant_list = restaurant_list.filter((restaurant) =>
      searchExp.test(restaurant.title)
    );
  }
  return (
    <div className="restaurant_chains_onboarding_main">
      <div className="col-6 pl-0">
        <NewInputText
          name="location_code"
          inputType="text"
          onChange={localProps.onChangeHandler}
          onFocusOut={localProps.onFocusOut}
          value={state.location_code}
          labelText="Location Code"
          helpTextDisplay={true}
          helperTextBottom="Enter your Location Code if any"
          controlClass={"outlined-helperText"}
        />
      </div>
      <div className="col-12 restaurant_chains_onboarding_main_section_third">
        <div className="section_third_two_width mb-4 mb-md-0 mb-lg-0 mb-xl-0">
          <NewInputText
            extraClass="mt-0 mb-0"
            name="search"
            inputType="search"
            onChange={localProps.onChangeHandler}
            value={state.search}
            labelText="Search below using name or code"
            controlClass={"outlined-helperText"}
          />
        </div>
        <div className="section_third_one_width">
          <AddButtonIconComponent
            buttonText="Suggest New"
            onClick={localProps.onToggleHandler("is_suggest_new_open", true)}
            fontIcon="fa fa-plus"
            colorCss="red"
          />
        </div>
      </div>
      <div className="col-7 col-sm-7 col-md-12 col-lg-12 col-xl-12 p-0 restaurant_chains_onboarding_main_divone">
        <h4>Select Your Chain</h4>
        <h5 className="mt-2 mb-3">
          Select a Chain your food establishment belongs
        </h5>
      </div>
      <div className="restaurant_type_onboarding_main">
        <div>
          <div className="cuisine-main restaurant-chain-display-mobile-margin">
            <div
              className={
                restaurant_list.length > 8 ? "cuisine-main-padding-border" : ""
              }
            >
              <div
                id="box-style"
                className="cuisine-main-padding"
                // className="mobile-device-chains-cls"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {restaurant_list.map((restaurant, index) => (
                  <IconboxReusableComponent
                    key={index}
                    src={restaurant.icon}
                    title={restaurant.title}
                    classSection={
                      restaurant._id === state.restaurant_chain_id
                        ? "restaurant-chain-icon-box restaurant-chain-icon-box-active"
                        : "restaurant-chain-icon-box"
                    }
                    onClick={localProps.onToggleHandler(
                      "restaurant_chain_id",
                      restaurant._id
                    )}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantChainsListComponent;
